import { TableColumn } from '../../../../components/DataTable/TableColumn';
import { Refund, RefundStatus } from '../../../../interfaces/Refund/Refund';
import { TextColumn } from '../../../../components/DataTable/TextColumn';
import { Pagination } from '../../../../interfaces/Pagination';
import { DataTable } from '../../../../components/DataTable/DataTable';
import { useLocalizedText } from '../../../../hooks/useLocalizedText';

type RefundsTableProps = {
  refunds: Refund[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
  loading: boolean;
};

export const RefundsTable = ({
  refunds,
  totalCount,
  pagination,
  onPagination,
  loading,
}: RefundsTableProps) => {
  const t = useLocalizedText();

  const refundNameMap: Record<RefundStatus, string> = {
    PENDING: t('account.refunds.status_name.pending'),
    SUCCESS: t('account.refunds.status_name.success'),
    REJECTED: t('account.refunds.status_name.rejected'),
  };

  const columns: TableColumn<Refund>[] = [
    {
      id: 'name',
      name: t('account.refunds.product'),
      accessor: (row) => <TextColumn value={row.name} />,
    },
    {
      id: 'status',
      name: t('account.refunds.status'),
      accessor: (row) => (
        <TextColumn
          value={
            refundNameMap[row.status] ??
            t('account.refunds.status_name.unknown')
          }
        />
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      totalCount={totalCount}
      rows={refunds}
      limit={pagination.pageSize}
      setLimit={(newLimit) => onPagination({ page: 0, pageSize: newLimit })}
      page={pagination.page}
      setPage={(newPage) => onPagination({ ...pagination, page: newPage })}
      loading={loading}
    />
  );
};
